
export const getStandardTemplate = (lang: string) => {
  const standardSubjects: Record<string, string> = {
    ru: "Напоминание об оплате счета № {invoiceNo}",
    cs: "Připomenutí platby faktury č. {invoiceNo}",
    en: "Reminder: Invoice Payment Due No. {invoiceNo}",
  };

  const subject = standardSubjects[lang] || standardSubjects.en;

  if (lang === "ru") {
    return {
      subject,
      body: `Здравствуйте,
Это напоминание об оплате счета № {invoiceNo}, выставленного {issueDate} на сумму {amount}.
На данный момент оплата еще не зафиксирована в системе.

Как произвести оплату:
{paymentDetails}

Если оплата уже была отправлена, пожалуйста, проигнорируйте это сообщение.

С уважением,
{companyName}`,
    };
  } else if (lang === "cs") {
    return {
      subject,
      body: `Dobrý den,
toto je připomenutí platby faktury č. {invoiceNo}, vystavené dne {issueDate} v částce {amount}.
V tuto chvíli nebyla platba v systému dosud zaznamenána.

Jak provést platbu:
{paymentDetails}

Pokud již byla platba odeslána, prosím, považujte tuto zprávu za bezpředmětnou.

S pozdravem,
{companyName}`,
    };
  } else {
    return {
      subject,
      body: `Hello,
This is a reminder regarding payment for invoice No. {invoiceNo}, issued on {issueDate} in the amount of {amount}.
At this time, the payment has not yet been recorded in the system.

How to make a payment:
{paymentDetails}

If the payment has already been sent, please disregard this message.

Kind regards,
{companyName}`,
    };
  }
};

export const getSoftTemplate = (lang: string) => {
  const softSubjects: Record<string, string> = {
    ru: "Счет № {invoiceNo}",
    cs: "Faktura č. {invoiceNo}",
    en: "Invoice No. {invoiceNo}",
  };

  const subject = softSubjects[lang] || softSubjects.en;

  if (lang === "ru") {
    return {
      subject,
      body: `Здравствуйте,

Направляю вам счёт № {invoiceNo} от {issueDate} на сумму {amount}.

Реквизиты для оплаты:
{paymentDetails}

С уважением,
{companyName}`,
    };
  } else if (lang === "cs") {
    return {
      subject,
      body: `Dobrý den,
posílám Vám fakturu č. {invoiceNo} ze dne {issueDate} v částce {amount}.

Platební údaje:
{paymentDetails}

S pozdravem,
{companyName}`,
    };
  } else {
    return {
      subject,
      body: `Hello,
Please find invoice No. {invoiceNo}, issued on {issueDate} for the amount of {amount}.

Payment details:
{paymentDetails}

Kind regards,
{companyName}`,
    };
  }
};

export const getTemplateByStatus = (status: string, lang: string) => {
  if (status === "overdue") {
    return getStandardTemplate(lang);
  }
  return getSoftTemplate(lang);
};
